import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IPlatformUserEmailConfirmationIm } from '../platform-user-email-confirmation-im.model';
@Injectable({ providedIn: 'root' })
export class PlatformUserEmailConfirmationService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/PlatformUserEmailConfirmation`;
  }
  post(platformUserEmailConfirmationIm: IPlatformUserEmailConfirmationIm): Observable<any> {
    const headers = this.createHeaders();
    return this.http.post<any>(this.baseUrl, platformUserEmailConfirmationIm, { headers });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
